import { useEffect, useRef, useState } from "react";
import { Control, Controller, FieldValues } from "react-hook-form";

import Select, { SelectItem } from "../form-control/select";
import * as Apis from "../../apis/public.api";

import { textChooser } from "../../util/textChooser";
import { ICountry, useCountries } from "../../hooks/useCountries";
import { IUserAddresses } from "../../constants/app.dto";


interface IAddressInformation {
  control: Control<FieldValues, any>;
  address?: IUserAddresses;
}

export default function AddressInformation({ control, address }: IAddressInformation) {
  const [currentCountry, setCountry] = useState<number>();
  const [currentDepartment, setDepartment] = useState<number>();
  const [currentCity, setCity] = useState<number>();
  const [currentDistrict, setDistrict] = useState<number>();
  const [departments, setDepartments] = useState<Array<Object>>([]);
  const [cities, setCities] = useState<Array<Object> | null>();
  const [districts, setDistricts] = useState<Array<Object> | null>();

  const { data, isLoading } = useCountries();

  const countries = data && data.map((item: ICountry) => ({ id: item.idCountry, label: item.country }));

  async function getDepartments() {
    const response = await Apis.getDepartments(currentCountry ?? 0);

    const departmentsList = response && response.map((item: any) => ({ id: item.idDepartments, label: item.departamento }))

    setDepartments(departmentsList);
  }

  async function getCities() {
    const response = await Apis.getProvinces(currentDepartment ?? 0);

    const citiesList = response && response.map((item: any) => ({ id: item.idProvince, label: item.province }))

    setCities(citiesList);
  }

  async function getDistricts() {
    const response = await Apis.getDistricts(currentCity ?? 0);

    const districtList = response && response.map((item: any) => ({ id: item.idDistrict, label: item.district }))

    setDistricts(districtList);
  }

  useEffect(() => {
    setDepartments([])
    setCities([]);
    setDistricts([])
    setDepartment(0);
    setCity(0);

    getDepartments()
  }, [currentCountry]);

  useEffect(() => {
    setCities([]);
    getCities();
  }, [currentDepartment])

  useEffect(() => {
    setDistricts([]);
    getDistricts();
  }, [currentCity])
  
  return (
    <>
      <div className="row">
        <div className="col-sm-12 col-md-6">
          <Controller name="addresses.address" defaultValue={address?.address} rules={{ required: true }} control={control} render={({ field: { onChange, value } }) =>
            <Select
              options={countries}
              onChange={(e) => {
                onChange(e);
                setCountry(parseInt(e.target.value));
              }}
              value={value}
              label={textChooser("txt96")}
            />
          } />

        </div>
        {!!departments?.length && (
          <div className="col-sm-12 col-md-6">
            <Controller name="addresses.location" defaultValue={address?.location} control={control} render={({ field: { onChange, value } }) =>
              <Select
                onChange={(e) => {
                  onChange(e)
                  setDepartment(parseInt(e.target.value));
                }}
                value={value}
                options={departments as SelectItem[]}
                label={textChooser("txt97")}
              />
            } />
          </div>
        )}
      </div>

      <div className="row">
        {!!cities?.length && (
          <div className="col-sm-12 col-md-6">
            <Controller name="addresses.city" defaultValue={address?.city} control={control} render={({ field: { onChange, value } }) =>
              <Select
                onChange={(e) => {
                  onChange(e)
                  setCity(parseInt(e.target.value));
                }}
                value={value}
                options={cities as SelectItem[]}
                label={textChooser("txt98")}
              />
            } />
          </div>
        )}

        {!!districts?.length && (
          <div className="col-sm-12 col-md-6">
            <Controller name="addresses.district" defaultValue={address?.district} control={control} render={({ field: { onChange, value } }) =>
              <Select
                options={districts as SelectItem[]}
                value={value}
                onChange={(e) => {
                  onChange(e)
                  setDistrict(parseInt(e.target.value));
                }}
                label={textChooser("txt99")}
              />
            } />
          </div>
        )}
      </div>
    </>
  );
}